import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@shared/utils";

type TextVariant =
  | "display"
  | "display-md"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "title"
  | "body"
  | "body-sm";

type TextAs = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span" | "label";

interface TextProps extends HTMLAttributes<HTMLElement> {
  variant?: TextVariant;
  as?: TextAs;
  children: ReactNode;
}

const variantToClass: Record<TextVariant, string> = {
  display: "text-display font-bold",
  "display-md": "text-display-md font-bold",
  h1: "text-h1 font-bold",
  h2: "text-h2 font-semibold",
  h3: "text-h3 font-semibold",
  h4: "text-h4 font-medium",
  h5: "text-h5 font-medium",
  title: "text-title font-semibold",
  body: "text-body font-regular",
  "body-sm": "text-body-sm font-regular",
};

/**
 * Typographic Text atom.
 * Renders a semantic HTML element with the correct design-system text style.
 */
export function Text({
  variant = "body",
  as: Tag = "p",
  className,
  children,
  ...props
}: TextProps) {
  return (
    <Tag className={cn(variantToClass[variant], className)} {...props}>
      {children}
    </Tag>
  );
}
